import UObject from "@repo/utils/UObject";
import UHTMLScriptElement from "@repo/utils-client/UHTMLScriptElement";

import { AnalyticsEvents, Registration } from "~/analytics/client";
import appSettings from "~/appSettings";
import Marketing from "~/utils/Marketing";

const id = appSettings.marketing.gtagId;

declare global {
  interface Window {
    dataLayer: object[];
  }
}

export default (): Registration.Conversion => {
  if (!id) return;
  if (import.meta.env.APP_ENV !== "production") return;

  window.dataLayer ??= [];

  UHTMLScriptElement.inject(
    `https://www.googletagmanager.com/gtag/js?id=${id}`
  );

  function gtag(...args: any[]) {
    window.dataLayer.push(args);
  }
  gtag("js", new Date());
  gtag("config", id);

  const gaEventByName: UObject.PartialBy<
    Record<keyof AnalyticsEvents["conversion"], string>,
    "SnapchatOnlyLogin"
  > = {
    // TODO: Figure out what value property should be for signup or if we should
    // even track it with GA
    Signup: "",
    "Credit Account Open": "credit_account_open",
    "Make Credit Line Payment": "make_first_credit_line_payment",
  };

  return {
    identify() {
      // Do nothing
    },
    track(name, properties) {
      if (!gaEventByName[name]) return;

      const tier = Marketing.useTier(properties);
      const expectedLtv = Marketing.useExpectedLtv(properties);
      const price = Marketing.useTransactionPrice(properties);

      gtag("event", gaEventByName[name], {
        currency: appSettings.currency,
        value: expectedLtv,
        transaction_id: properties.accountId,
        items: [
          {
            item_category_id: tier,
            item_name: tier,
            item_id: tier,
            price,
            quantity: 1,
          },
        ],
      });
    },
  };
};
